import { render, staticRenderFns } from "./AutoTopUpModal.vue?vue&type=template&id=56f5d3f8"
import script from "./AutoTopUpModal.vue?vue&type=script&lang=js"
export * from "./AutoTopUpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports